import { render, staticRenderFns } from "./transferts-services.vue?vue&type=template&id=435117b4&scoped=true"
import script from "./transferts-services.vue?vue&type=script&lang=js"
export * from "./transferts-services.vue?vue&type=script&lang=js"
import style0 from "./transferts-services.vue?vue&type=style&index=0&id=435117b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435117b4",
  null
  
)

export default component.exports